import {useQuery} from '@tanstack/react-query';
import {BiometricsService} from '../services/biometricsService';

// Cache keys are scoped by userId so that if the viewing user changes mid-
// session (e.g. an org admin lands here after impersonating a patient, or a
// caregiver switches between sub-patients) the cache doesn't hand back the
// previous patient's readings. Pass the current viewer's id from auth.

export function useLatestBiometrics(userId?: number | null) {
    return useQuery({
        queryKey: ['biometrics-latest', userId ?? null],
        queryFn: () => BiometricsService.getLatest(),
        staleTime: 2 * 60 * 1000,
        enabled: userId != null,
    });
}

export function useBiometricHistory(userId?: number | null) {
    return useQuery({
        queryKey: ['biometrics-history', userId ?? null],
        queryFn: () => BiometricsService.getAll(),
        staleTime: 2 * 60 * 1000,
        enabled: userId != null,
    });
}
